<template>
  <v-layout column justify-center align-center>  
    <div ref="ui" id="firebaseui-auth-container"></div>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

import { auth } from '@/plugins/firebase'

let firebaseui = require('firebaseui')
import 'firebaseui/dist/firebaseui.css'

export default {
  mounted() {
    if(this.$store.state.user) {
      this.$router.push({ name: 'home' })
    }

    let ui = firebaseui.auth.AuthUI.getInstance()
    
    let uiConfig = {
      signInSuccessUrl: this.$route.redirectedFrom || '/',
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        // firebase.auth().FacebookAuthProvider.PROVIDER_ID,
        // firebase.auth().TwitterAuthProvider.PROVIDER_ID,
        // firebase.auth().GithubAuthProvider.PROVIDER_ID,
        // firebase.auth.EmailAuthProvider.PROVIDER_ID,
        // firebase.auth().PhoneAuthProvider.PROVIDER_ID,
        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: ({ user }) => {
          this.$store.commit('SET_USER', user)
          this.$router.push({name: 'home'})
        }
      },
      tosUrl: '/terms',
      privacyPolicyUrl: '/privacy-policy'
    }
    // check for existing AuthUI instance if not create one
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(auth)
    }
    ui.start("#firebaseui-auth-container", uiConfig)
  }
}
</script>
